"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Screen404 = void 0;
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const components_1 = require("@/components");
const constants_1 = __importDefault(require("@/constants"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Screen404 = () => (react_1.default.createElement("div", { className: styles_scss_1.default.screen404 },
    react_1.default.createElement(components_1.Meta, { title: constants_1.default.screen404.helmetTitle }),
    react_1.default.createElement(components_1.Page404, null)));
exports.Screen404 = Screen404;
exports.default = react_router_1.withRouter(exports.Screen404);
